export default function OrderDetailsHeader({ customerName, customerPhone, customerEmail }) {
    return (
        <table className="table table-striped">
            <tbody>
                <tr>
                    <td>اسم العميل</td>
                    <td>{customerName}</td>
                </tr>
                <tr>
                    <td>رقم التواصل</td>
                    <td>{customerPhone}</td>
                </tr>
                <tr>
                    <td>البريد الالكتروني</td>
                    <td>{customerEmail}</td>
                </tr>
            </tbody>
        </table>
    )
}